import React from 'react'
import { Button } from 'react-bootstrap'
import CustomModal from '../../CustomModal/CustomModal'
import ConfirmationModal from '../../ConfirmationModal'
import { getCurrencySymbolByCountryCode } from '../../../constants/currency'

export const SwitchPlanModal = ({
  currency,
  interval,
  switchPlanSuggestionModalShow,
  setSwitchPlanSuggestionModalShow,
  confirmSwitchPlanModalShow,
  setconfirmSwitchPlanModalShow,
  switchPlanProcessing,
  eligiblePlanWithPrices,
  currentPlanWithPrices,
  setCancelTrialModalShow,
  onContinueCancellation,
  handleConfirmSwitchPlanClick,
  instantSwitchPlan
}) => {
  const symbol = getCurrencySymbolByCountryCode(currency) || currency
  const period = interval === 'year' || interval === 'yearly' ? 'yearly' : 'monthly'
  const newPrice = eligiblePlanWithPrices?.prices?.[period]?.value
  const oldPrice = currentPlanWithPrices?.prices?.[period]?.value

  if (!switchPlanSuggestionModalShow && !confirmSwitchPlanModalShow) return null

  if (confirmSwitchPlanModalShow) {
    return (
      <div className="p-4">
        <h3 className="mb-3 font-weight-bold text-center">Confirm downgrade</h3>
        <div className="p-32px font-18 text-center">
          Complete your move to the lower plan. You will be charged now for your new plan.
        </div>
        <div className="d-flex justify-content-end mt-4">
          {switchPlanProcessing ? (
            <div className="spinner-border text-primary" role="status" />
          ) : (
            <>
              <Button
                variant="secondary"
                className="me-2"
                onClick={() => {
                  setconfirmSwitchPlanModalShow(false)
                  setSwitchPlanSuggestionModalShow(true)
                }}
              >
                Cancel
              </Button>
              <Button variant="primary" onClick={instantSwitchPlan}>
                Confirm
              </Button>
            </>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="p-4 text-center">
      <h3 className="mb-3 font-weight-bold">Switch to a cheaper plan</h3>
      <p className="grey mb-4 font-18">Based on your usage you can switch to a lower plan</p>
      <div className="mb-4 d-flex justify-content-center align-items-center">
        {oldPrice && (
          <>
            <div className="d-flex flex-column align-items-center">
              <span className="font-weight-bold text-muted text-decoration-line-through font-38">
                {symbol}
                {oldPrice}
              </span>
              <span className="text-muted font-20">{currentPlanWithPrices?.label}</span>
            </div>
            <span className="font-weight-bold mx-3 font-38 pb-4">&rarr;</span>
          </>
        )}
        <div className="d-flex flex-column align-items-center">
          <span className="font-weight-bold font-38">
            {symbol}
            {newPrice}
          </span>
          <span className="font-20 font-weight-bold">{eligiblePlanWithPrices?.label}</span>
        </div>
      </div>
      <div className="d-flex flex-column w-100 gap-3">
        <Button className="action-btn w-100" onClick={handleConfirmSwitchPlanClick}>
          Switch plan
        </Button>
        <Button
          variant="danger"
          className="track-continue-cancellation w-100"
          onClick={() => {
            if (onContinueCancellation) {
              onContinueCancellation()
            } else {
              setSwitchPlanSuggestionModalShow(false)
              setCancelTrialModalShow(true)
            }
          }}
        >
          Continue Cancellation
        </Button>
      </div>
    </div>
  )
}
